export default __webpack_public_path__ + "static/media/crop-y.d6261de8.png";